import webview from '@adapter/webview';
import { GobblerNOFWebOnbCtaClick } from '@groww-tech-pvt/gobbler-proto-ts/dist';
import { Button, VARIANTS } from '@groww-tech-pvt/ui-toolkit';
import { useEffect } from 'react';
import { ONBOARDING_FLOW_SCREENS } from 'core/constants';
import useOnboardingStore from 'core/store';
import ModalPortal from 'src/components/ModalPortal';
import { trackEvent } from 'src/utils/adapter/gobbler';
import { useRedirectToPreviousPage } from 'src/utils/hook';
import { getIsDomain915 } from 'src/utils/config/domainConfig';

const OnboardingBackPopup = () => {
  const WV = webview();
  const { goBackToPreviousPage } = useRedirectToPreviousPage('BACK_POPUP');
  const isExitPopupOpen = useOnboardingStore(s => s.isExitPopupOpen);
  const setIsExitPopupOpen = useOnboardingStore(s => s.setIsExitPopupOpen);
  const isDomain915 = getIsDomain915();
  const activeScreen = useOnboardingStore(s => s.activeScreen);
  const hideHistoryBackPopup = useOnboardingStore(s => s.hideHistoryBackPopup);
  const skipExitIntercept =
    activeScreen === ONBOARDING_FLOW_SCREENS.SUCCESS_SCREEN ||
    activeScreen === ONBOARDING_FLOW_SCREENS.ONBOARDING_PENDING_SCREEN ||
    hideHistoryBackPopup;

  useEffect(() => {
    if (isDomain915 || skipExitIntercept) return;
    window.history.pushState(null, '', window.location.href);

    const handlePopState = () => {
      window.history.pushState(null, '', window.location.href);
      setIsExitPopupOpen(true);
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [skipExitIntercept, setIsExitPopupOpen]);

  const handleConfirmExit = () => {
    setIsExitPopupOpen(false);
    trackEvent('GobblerNOFWebOnbCtaClick', GobblerNOFWebOnbCtaClick, { buttonText: 'Do it later', buttonAction: 'do_it_later' });
    if (WV.isActive) {
      WV.sendMessage({ action: 'BACK', params: null });
    } else {
      goBackToPreviousPage();
    }
  };

  if (!isExitPopupOpen) return null;

  return (
    <ModalPortal modalTitle="" setIsOpen={setIsExitPopupOpen} canClose={false}>
      <div className="flex flex-col gap-6 items-center">
        <div className="flex flex-col gap-1 text-center">
          <div className="displaySmall">You are almost there!</div>
          <div className="contentSecondary bodyBase">
            Setting up your account will only take a few more seconds
          </div>
        </div>
        <div className="flex gap-1.5 w-full flex-col">
          <div className="flex-1">
            <Button
              buttonText="Continue Setup"
              onClick={() => setIsExitPopupOpen(false)}
              variant={VARIANTS.PRIMARY}
              isFullWidth={true}
            />
          </div>
          <div className="flex-1">
            <Button
              buttonText="Do it later"
              onClick={handleConfirmExit}
              variant={VARIANTS.TERTIARY}
              isFullWidth={true}
              isAccent={true}
            />
          </div>
        </div>
      </div>
    </ModalPortal>
  );
};

export default OnboardingBackPopup;
